import { useQuery } from "@tanstack/react-query";
import { documentTagsApi, type DocumentTagDto } from "@/api/reportsV32";

// LLM & Reports v3.2 §6.4 — fetches the active document-tag lookup
// once per session and reuses it across the upload UI. Tags are
// returned ordered by SortOrder; the dropdowns can render the array
// straight through.
export function useDocumentTags() {
  return useQuery<DocumentTagDto[]>({
    queryKey: ["document-tags"],
    queryFn: () => documentTagsApi.list(),
    staleTime: 5 * 60 * 1000, // tags rarely change at runtime
  });
}
